'use strict'

import ObjectCardWrapper from '../../components/Card/ObjectCardWrapper.vue'
// import { axiosGet, axiosPost } from '../../axios/axios.js'

export function checkProvidableVehicleManagementAccess (user) {
  return user.hasOperation('vehicleProvisionManagement') || checkProvidableVehicleApprovalAccess(user)
}

export function checkProvidableVehicleApprovalAccess (user) {
  return user.hasOperation('vehicleProvisionApproval')
}
export function createProvidableVehicle (target, createConfig, onCreated) {
  const objectParams = createConfig && createConfig.objectParams || {}

  const dialog = target.$d.dialog(target).show({
    maximizedOnNarrow: true,
    persistent: true,
    noWrap: true,
    contentWidth: 800,
    contentComponent: ObjectCardWrapper,
    contentProps: {
      objectId: -1,
      objectType: 'vehicle',
      objectParams: objectParams,
      subtypeKey: 'vehicleProvided',
      create: true,
      createConfig: createConfig,
      modeCustom: true
    },
    componentHandlers: {
      created: (objectId) => {
        console.log('Создан объект, id=', objectId)

        if (onCreated) {
          onCreated(objectId)
        }
        dialog.hide()
      },
      saved: () => {}, // не будет, т.к. закрываем в created
      close: () => {
        dialog.hide()
      }
    }
  })
}
